<h1 class="page-title">My Report</h1>

@if (reportData) {
  <app-emissions-chart [reportData]="reportData"></app-emissions-chart>
}
